export default __webpack_public_path__ + "static/media/480_dummy2016-heimtier01-de.07fd5736.png";